import { NgModule } from '@angular/core';
import { DefaultDirective } from './default/default';

@NgModule({
	declarations: [
    DefaultDirective
  ],
	imports: [],
	exports: [
    DefaultDirective
  ]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts